import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getJwt, setJwt } from './jwtLocalstorage';
var ERROR_TEXT = 'Error refreshing token';
var wasLoggedIn = function wasLoggedIn() {
  try {
    var token = getJwt();
    if (!token) {
      throw new Error('no token in local storage');
    }
    var _token$split = token.split('.'),
      _token$split2 = _slicedToArray(_token$split, 2),
      jwtBody = _token$split2[1];
    var _JSON$parse = JSON.parse(atob(jwtBody)),
      cheggTokens = _JSON$parse.cheggTokens;
    return !!(cheggTokens && cheggTokens.access_token);
  } catch (e) {
    return false;
  }
};
var endpoint = function endpoint(authApiUrl) {
  var path = wasLoggedIn() ? '/refresh' : '/token';
  return "".concat(authApiUrl).concat(path, "?client=wbe");
};
var refresh = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(authApiUrl, updateHostApp) {
    var authResponse, data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch(endpoint(authApiUrl), {
            method: 'post',
            credentials: 'include'
          });
        case 3:
          authResponse = _context.sent;
          _context.next = 6;
          return authResponse.json();
        case 6:
          data = _context.sent;
          setJwt(data.jwt);

          // This is necessary to keep the redux store in sync in the host app with the widget.
          // To call set user incase anything has changed
          if (updateHostApp) {
            updateHostApp(data.jwt);
          }
          return _context.abrupt("return", Promise.resolve(data.jwt));
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", Promise.reject(new Error(ERROR_TEXT)));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return function refresh(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var wfeTokenRefresh = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(authApiUrl, response, onAuthUpdate) {
    var _body$errors;
    var status, body, unauthenticated;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          status = response ? response.status : undefined;
          if (!response) {
            _context2.next = 7;
            break;
          }
          _context2.next = 4;
          return response.json();
        case 4:
          _context2.t0 = _context2.sent;
          _context2.next = 8;
          break;
        case 7:
          _context2.t0 = undefined;
        case 8:
          body = _context2.t0;
          unauthenticated = body === null || body === void 0 ? void 0 : (_body$errors = body.errors) === null || _body$errors === void 0 ? void 0 : _body$errors.find(function (err) {
            var _err$extensions;
            return ((_err$extensions = err.extensions) === null || _err$extensions === void 0 ? void 0 : _err$extensions.code) === 'UNAUTHENTICATED';
          });
          if (!(!response || unauthenticated || status === 401 || status === 403)) {
            _context2.next = 14;
            break;
          }
          _context2.next = 13;
          return refresh(authApiUrl, onAuthUpdate);
        case 13:
          return _context2.abrupt("return", _context2.sent);
        case 14:
          return _context2.abrupt("return", Promise.reject(new Error(response ? JSON.stringify({
            status: response.status
          }) : ERROR_TEXT)));
        case 15:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function wfeTokenRefresh(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
export default wfeTokenRefresh;